export type orderassuranceTabKey =
  | '全部'
  | '已驳回'
  | '待推送'
  | '审核完成'
  | '待销售审核'
  | '销售审核中'
  | '已推送'
type RadioDict = {
  [x in orderassuranceTabKey]: {
    key: string
    keyName: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderassuranceTabKey // 当前选中tab的key值
  dataSource: any[]
  isTableLoading?: boolean
  pagination: paginationOption
  searchParam: any
  selectedRows: any[]
  drawerVisible: boolean
  processDateSource: any[]
  isProcessTableLoading?: boolean
  processPagination: paginationOption
  currentProcess: any
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setSelectedRows'
  | 'setDrawerVisible'
  | 'setProcessDateSource'
  | 'setIsProcessTableLoading'
  | 'setProcessPagination'
  | 'setCurrentProcess'
interface Action {
  type: ActionType
  payload: any
}

const initialRadioDict: RadioDict = {
  全部: {
    key: '全部',
    keyName: '全部',
  },
  已驳回: {
    key: 'REJECTED',
    keyName: '已驳回',
  },
  待推送: {
    key: 'PENDING_PUSH',
    keyName: '待推送',
  },
  审核完成: {
    key: 'PASS',
    keyName: '审核完成',
  },
  待销售审核: {
    key: 'PENDING_SALES_AUDIT',
    keyName: '待销售审核',
  },
  销售审核中: {
    key: 'SALES_AUDITING',
    keyName: '销售审核中',
  },
  已推送: {
    key: 'PUSHED',
    keyName: '已推送',
  },
}
export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '全部',
  dataSource: [],
  isTableLoading: false,
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  drawerVisible: false,
  processDateSource: [],
  isProcessTableLoading: false,
  processPagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  currentProcess: '',
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setDrawerVisible':
      newstate.drawerVisible = action.payload
      return newstate
    case 'setProcessDateSource':
      newstate.processDateSource = action.payload
      return newstate
    case 'setIsProcessTableLoading':
      newstate.isProcessTableLoading = action.payload
      return newstate
    case 'setProcessPagination':
      newstate.processPagination = action.payload
      return newstate
    case 'setCurrentProcess':
      newstate.currentProcess = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKey = (val: orderassuranceTabKey): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any[]): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
export const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

export const setDrawerVisible = (val: boolean): Action => ({
  type: 'setDrawerVisible',
  payload: val,
})

export const setProcessDateSource = (val: any[]): Action => ({
  type: 'setProcessDateSource',
  payload: val,
})

export const setIsProcessTableLoading = (val: boolean): Action => ({
  type: 'setIsProcessTableLoading',
  payload: val,
})

export const setProcessPagination = (val: paginationOption): Action => ({
  type: 'setProcessPagination',
  payload: val,
})

export const setCurrentProcess = (val: any): Action => ({
  type: 'setCurrentProcess',
  payload: val,
})

export default reducer
export type orderassuranceTabKey =
  | '全部'
  | '已驳回'
  | '待推送'
  | '审核完成'
  | '待销售审核'
  | '销售审核中'
  | '已推送'
type RadioDict = {
  [x in orderassuranceTabKey]: {
    key: string
    keyName: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderassuranceTabKey // 当前选中tab的key值
  dataSource: any[]
  isTableLoading?: boolean
  pagination: paginationOption
  searchParam: any
  selectedRows: any[]
  drawerVisible: boolean
  processDateSource: any[]
  isProcessTableLoading?: boolean
  processPagination: paginationOption
  currentProcess: any
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setSelectedRows'
  | 'setDrawerVisible'
  | 'setProcessDateSource'
  | 'setIsProcessTableLoading'
  | 'setProcessPagination'
  | 'setCurrentProcess'
interface Action {
  type: ActionType
  payload: any
}

const initialRadioDict: RadioDict = {
  全部: {
    key: '全部',
    keyName: '全部',
  },
  已驳回: {
    key: 'REJECTED',
    keyName: '已驳回',
  },
  待推送: {
    key: 'PENDING_PUSH',
    keyName: '待推送',
  },
  审核完成: {
    key: 'PASS',
    keyName: '审核完成',
  },
  待销售审核: {
    key: 'PENDING_SALES_AUDIT',
    keyName: '待销售审核',
  },
  销售审核中: {
    key: 'SALES_AUDITING',
    keyName: '销售审核中',
  },
  已推送: {
    key: 'PUSHED',
    keyName: '已推送',
  },
}
export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '全部',
  dataSource: [],
  isTableLoading: false,
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  drawerVisible: false,
  processDateSource: [],
  isProcessTableLoading: false,
  processPagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  currentProcess: '',
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setDrawerVisible':
      newstate.drawerVisible = action.payload
      return newstate
    case 'setProcessDateSource':
      newstate.processDateSource = action.payload
      return newstate
    case 'setIsProcessTableLoading':
      newstate.isProcessTableLoading = action.payload
      return newstate
    case 'setProcessPagination':
      newstate.processPagination = action.payload
      return newstate
    case 'setCurrentProcess':
      newstate.currentProcess = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKey = (val: orderassuranceTabKey): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any[]): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
export const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

export const setDrawerVisible = (val: boolean): Action => ({
  type: 'setDrawerVisible',
  payload: val,
})

export const setProcessDateSource = (val: any[]): Action => ({
  type: 'setProcessDateSource',
  payload: val,
})

export const setIsProcessTableLoading = (val: boolean): Action => ({
  type: 'setIsProcessTableLoading',
  payload: val,
})

export const setProcessPagination = (val: paginationOption): Action => ({
  type: 'setProcessPagination',
  payload: val,
})

export const setCurrentProcess = (val: any): Action => ({
  type: 'setCurrentProcess',
  payload: val,
})

export default reducer
